import { SdkEvents } from "../index";
import { StoreModel } from "../../models/Index";

export default function userActivity(Store: StoreModel, event: any) {
    Store.sdk.events.emit(SdkEvents.UserActivity, event);
    return true;
}
